export default __webpack_public_path__ + "static/media/xfinity-med.7c55bf9f.png";